<template>
  <div class="vx-row">
    <div class="vx-col w-full">
      <div class="mb-3">
        <vs-input :label="$t('representative_number')" :placeholder="$t('representative_number')" v-model="formData.title" class="w-full"/>
        <validation-error :model-error="formDataErrors.title"></validation-error>
      </div>

      <div class="mb-3">
        <vs-input :label="$t('no')" :placeholder="$t('no')" v-model="formData.channel" class="w-full"/>
        <validation-error :model-error="formDataErrors.channel"></validation-error>
      </div>
    </div>
  </div>
</template>

<script>
import { EventBus } from '@/../eventbus'
import Transfer from '@/models/Transfer'

export default {
  name: 'Shared.Transfers.Edit',
  data () {
    return {
      formData: {},
      formDataErrors: {}
    }
  },
  mounted () {
    EventBus.$on('initTransferResetFormData', this.resetFormData)
    EventBus.$on('initTransferGetFormData', this.getFormData)
    EventBus.$on('initUpdateTransfer', this.updateFormData)
  },
  methods: {
    resetFormData () {
      this.formData = {
        id: '',
        title: '',
        channel: '',
        status: 0
      }
      this.formDataErrors = {}
    },
    async getFormData (id) {
      this.$vs.loading({container: '#EditTransferFormContainer'})
      try {
        const response = await Transfer.view({ id })
        this.formData = response.data.transfer
      } catch (e) {
        this.$swalHelper.displayCatchError({
          title: 'Error!',
          errorObject: e,
          confirmButton: this.$t('confirm')
        })
      }
      this.$vs.loading.close('#EditTransferFormContainer > .con-vs-loading')
    },
    async updateFormData () {
      this.$vs.loading({background: 'primary', color: '#fff', container: '#editTransferButton', scale: 0.45})
      try {
        if (!this.$store.getters.isFormInProgress) {
          this.$store.dispatch('setIsFormInProgress', true)

          const response = await Transfer.update(this.formData)

          this.$swalHelper.success({
            title: this.$t('action_success'),
            text: this.$t(response.data),
            confirmButton: this.$t('confirm')
          })

          this.$store.dispatch('setIsFormInProgress', false)

          this.resetFormData()
          this.$emit('editTransferSuccess')
        }
      } catch (e) {
        const errors = this.$swalHelper.displayCatchError({
          title: 'Error!',
          errorObject: e,
          confirmButton: this.$t('confirm')
        })

        this.formDataErrors = this.__getTranslatedValidationErrors(errors.validationErrors)
        this.$store.dispatch('setIsFormInProgress', false)
      }
      this.$vs.loading.close('#editTransferButton > .con-vs-loading')
    }
  }
}
</script>

<style lang="scss">
  #editTransferButton {
    .con-vs-loading {
      position: absolute !important;
    }
  }
</style>
